import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"16px","margin-bottom":"16px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 3 }

import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import { ToImage } from "@/utils/image";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import FileUpload from "@/components/FileUpload.vue";
import { Template } from "@/api/models/template/Template";
import { TemplateService } from "@/api/services/TemplateService";
import { TemplateAddRequest } from "@/api/models/template/TemplateAddRequest";
import { TemplateUpdateRequest } from "@/api/models/template/TemplateUpdateRequest";
import { TemplateListRequest } from "@/api/models/template/TemplateListRequest";


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateView',
  setup(__props) {

const total = ref<number>(0);

const listRequest = reactive<TemplateListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const templateList = ref<Template[]>([]);

const handleList = async () => {
  const res = await TemplateService.ListAll(listRequest);
  if (res.code === 0) {
    templateList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<TemplateAddRequest>({
  name: "",
  image_url: "",
  level: 1,
  price: 0,
  category: 1,
});

const submitAdd = async () => {
  const res = await TemplateService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<TemplateUpdateRequest>({
  id: 0,
  name: "",
  image_url: "",
  level: 0,
  is_delete: 0,
  price: 0,
  category: 0,
});

const handleUpdate = (record: Template) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await TemplateService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Template) => {
  const res = await TemplateService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Template) => {
  const res = await TemplateService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "模版名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "排序",
    dataIndex: "level",
    align: "center",
  },
  {
    title: "模版分类",
    dataIndex: "category",
    align: "center",
  },
  {
    title: "图片",
    dataIndex: "image_url",
    align: "center",
  },
  {
    title: "价格",
    dataIndex: "price",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openAdd.value = true)),
        style: {"margin-bottom":"0"}
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createTextVNode(" 添加模版 ")
        ])),
        _: 1
      }),
      _createVNode(_component_a_form, { layout: "inline" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "搜索类别" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                style: {"min-width":"120px"},
                value: listRequest.category,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((listRequest.category) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("通用")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("极致")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 3 }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode("简约")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 4 }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("生日")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: handleList
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("搜索")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_table, {
      columns: columns,
      "data-source": templateList.value,
      pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
      bordered: ""
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'category')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.category === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "通用"))
                : _createCommentVNode("", true),
              (record.category === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "极致"))
                : _createCommentVNode("", true),
              (record.category === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "简约"))
                : _createCommentVNode("", true),
              (record.category === 4)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "生日"))
                : _createCommentVNode("", true)
            ], 64))
          : (column.dataIndex === 'image_url')
            ? (_openBlock(), _createBlock(_component_a_image, {
                key: 1,
                src: _unref(ToImage)(record.image_url),
                style: {"height":"60px","width":"auto"}
              }, null, 8, ["src"]))
            : (column.dataIndex === 'is_delete')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (record.is_delete === 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "green"
                      }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode("正常")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.is_delete === 2)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "red"
                      }, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createTextVNode("回收站")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (column.dataIndex === 'create_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                : (column.dataIndex === 'operator')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (handleUpdate(record)),
                        type: "primary",
                        style: { marginRight: '8px' }
                      }, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createTextVNode("编辑 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (submitDelete(record)),
                        type: "primary",
                        style: {
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode("删除 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (submitDrop(record)),
                        type: "primary",
                        style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                      }, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createTextVNode("彻底删除 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "pagination"]),
    _createVNode(_component_a_modal, {
      open: openAdd.value,
      "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((openAdd).value = $event)),
      title: "添加模版数据",
      onOk: submitAdd,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: addRequest }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "模版名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.name,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "优先级" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: addRequest.level,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addRequest.level) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "价格" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: addRequest.price,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((addRequest.price) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "类别" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: addRequest.category,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((addRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode("通用")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createTextVNode("极致")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 3 }, {
                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                        _createTextVNode("简约")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 4 }, {
                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createTextVNode("生日")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "图片" }, {
              default: _withCtx(() => [
                _createVNode(FileUpload, {
                  modelValue: addRequest.image_url,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addRequest.image_url) = $event)),
                  style: {"display":"block"}
                }, null, 8, ["modelValue"]),
                (addRequest.image_url !== '')
                  ? (_openBlock(), _createBlock(_component_a_image, {
                      key: 0,
                      src: _unref(ToImage)(addRequest.image_url),
                      style: {"max-height":"150px","display":"block","margin-top":"10px"}
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: openUpdate.value,
      "onUpdate:open": _cache[13] || (_cache[13] = ($event: any) => ((openUpdate).value = $event)),
      title: "修改模版数据",
      onOk: submitUpdate,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: updateRequest,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "模版名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.name,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((updateRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "优先级" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: updateRequest.level,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((updateRequest.level) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "类别" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.category,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((updateRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                        _createTextVNode("通用")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createTextVNode("极致")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 3 }, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createTextVNode("简约")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 4 }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("生日")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.is_delete,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((updateRequest.is_delete) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "图片" }, {
              default: _withCtx(() => [
                _createVNode(FileUpload, {
                  modelValue: updateRequest.image_url,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((updateRequest.image_url) = $event)),
                  style: {"display":"block"}
                }, null, 8, ["modelValue"]),
                _createVNode(_component_a_image, {
                  src: _unref(ToImage)(updateRequest.image_url),
                  style: {"max-height":"150px","display":"block","margin-top":"10px"}
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})